import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import Footer from 'components/common/Footer';
import { ReactComponent as SuccessIcon } from 'assets/documentRequestIcons/success-document-request.svg';
import { DOCUMENT_REQUEST_STATUSES } from 'stores/documentRequestStore';
import './styles.scss';

const SuccessScreen = ({ status = DOCUMENT_REQUEST_STATUSES.PROVIDED }) => {
  const i18n = useContext(i18nContext);
  const logoPath = process.env.REACT_APP_LOGO_PATH;

  // Determine which messages to show based on status
  const isCompleted = status === DOCUMENT_REQUEST_STATUSES.COMPLETED;
  const titleKey = isCompleted ? 'documentRequest.completed.title' : 'documentRequest.success.title';
  const descriptionKey = isCompleted ? 'documentRequest.completed.description' : 'documentRequest.success.description';

  return (
    <div className='document-request-container'>
      <div className='document-request-header'>
        <a href={process.env.REACT_APP_LINK_HOME_PAGE} className='logo'>
          <img src={logoPath} alt='Logo' className='icon-logo' />
        </a>
      </div>

      <div className='document-final-screen-content'>
        <div className='final-screen-card'>
          <div className='final-icon-container'>
            <SuccessIcon className='final-screen-icon' />
          </div>

          <div className='final-screen-content'>
            <h1 className='final-screen-title'>{i18n.getMessage(titleKey)}</h1>

            <p className='final-screen-description'>{i18n.getMessage(descriptionKey)}</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

SuccessScreen.propTypes = {
  status: PropTypes.string
};

export default SuccessScreen;
